// Browser fallback printing: renders an 80 mm thermal-style receipt and opens the print dialog.
const money = (v) => `$${Number(v || 0).toFixed(2)}`;

const esc = (s) =>
  String(s ?? '').replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]));

export function receiptHtml(order) {
  const short = (order.id || '').slice(0, 8).toUpperCase();
  const when = order.created_at || order.createdAt;
  const rows = (order.items || [])
    .map((it) => {
      const grouped = {};
      (it.modifiers || []).forEach((m) => {
        const g = m.groupName || 'Options';
        grouped[g] = grouped[g] || [];
        grouped[g].push(`${m.name}${Number(m.price) > 0 ? ` (+${money(m.price)})` : ''}`);
      });
      const mods = Object.entries(grouped)
        .map(([g, v]) => `<div class="mod">${esc(g)}: ${esc(v.join(', '))}</div>`)
        .join('');
      return `<div class="row"><span>${it.qty}x ${esc(it.name)}</span><span>${money(
        (it.price || 0) * (it.qty || 1)
      )}</span></div>${mods}`;
    })
    .join('');

  return `<!doctype html><html><head><meta charset="utf-8"><title>Receipt ${short}</title>
<style>
  @page { size: 80mm auto; margin: 3mm; }
  body { font-family: "Courier New", monospace; width: 72mm; font-size: 12px; color: #000; margin: 0; }
  h1 { font-size: 18px; text-align: center; margin: 0 0 2px; letter-spacing: 1px; }
  .sub { text-align: center; font-size: 11px; margin-bottom: 6px; }
  .big { text-align: center; font-size: 20px; font-weight: 700; margin: 4px 0 8px; }
  .hr { border-top: 1px dashed #000; margin: 6px 0; }
  .row { display: flex; justify-content: space-between; gap: 8px; font-weight: 700; }
  .mod { padding-left: 12px; font-weight: 400; font-size: 11px; }
  .tot { display: flex; justify-content: space-between; font-size: 14px; font-weight: 700; }
  .notes { border: 1px solid #000; padding: 4px; margin-top: 6px; font-size: 11px; }
  .ctr { text-align: center; margin-top: 8px; }
</style></head><body>
  <h1>WRAPPUS DONAIR</h1>
  <div class="sub">ONLINE ORDER · ${esc((order.type || 'pickup').toUpperCase())}</div>
  <div class="big">#${short}</div>
  <div class="hr"></div>
  <div>${when ? esc(new Date(when).toLocaleString()) : ''}</div>
  ${order.scheduledFor ? `<div><b>SCHEDULED: ${esc(new Date(order.scheduledFor).toLocaleString())}</b></div>` : '<div>ASAP</div>'}
  <div class="hr"></div>
  <div><b>${esc(order.customerName || '-')}</b></div>
  ${order.customerPhone ? `<div>Tel: ${esc(order.customerPhone)}</div>` : ''}
  ${order.type === 'delivery' && order.deliveryAddress
      ? `<div>DELIVER TO:<br>${esc(order.deliveryAddress)}<br>${esc(
          [order.deliveryCity, order.deliveryState, order.deliveryPostal].filter(Boolean).join(', ')
        )}</div>`
      : ''}
  <div class="hr"></div>
  ${rows}
  <div class="hr"></div>
  <div class="row"><span>Subtotal</span><span>${money(order.subtotal)}</span></div>
  <div class="row"><span>GST (5%)</span><span>${money(order.gst ?? order.tax)}</span></div>
  ${order.pst ? `<div class="row"><span>PST (7%)</span><span>${money(order.pst)}</span></div>` : ''}
  ${order.deliveryFee ? `<div class="row"><span>Delivery</span><span>${money(order.deliveryFee)}</span></div>` : ''}
  ${order.loyaltyDiscount ? `<div class="row"><span>Loyalty</span><span>-${money(order.loyaltyDiscount)}</span></div>` : ''}
  <div class="tot"><span>TOTAL PAID</span><span>${money(order.total)}</span></div>
  ${order.notes ? `<div class="notes"><b>NOTES:</b> ${esc(order.notes)}</div>` : ''}
  <div class="ctr">Paid online (Stripe)<br>Thank you!</div>
</body></html>`;
}

export function printReceipt(order) {
  const w = window.open('', '_blank', 'width=380,height=680');
  if (!w) return false;
  w.document.write(receiptHtml(order));
  w.document.close();
  w.focus();
  setTimeout(() => {
    w.print();
  }, 350);
  return true;
}
